<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/ui/VSelect.vue";
import carStylesApi from "../api/resources/carStylesApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getCarMakes() {
      carStylesApi.index().then((response) => {
        this.options = response.data.map((style) => {
          return { text: style.name, value: style.id };
        });
      });
    },
  },

  created() {
    this.getCarMakes();
  },
};
</script>

<style></style>
